import {deleteCookie, setCookie} from '@github-ui/cookies'
import {useRef, useState, useSyncExternalStore} from 'react'

import {persistPullsPreferences} from '../helpers/pulls-preferences-api'

export const COOKIE_NAME = 'dashboard_surface_inbox_options_tip_dismissed'
export const LEGACY_COOKIE_NAME = 'dashboard_surface_default_view_tip_dismissed'
const COOKIE_EXPIRY_MS = 100 * 24 * 60 * 60 * 1000 // 100 days

const noop = () => () => {}

/**
 * Hook to manage and persist the dismissed state of the inbox-options tip.
 * Returns the current dismissed state and a function to dismiss the tip.
 *
 * Payload-as-truth: the dismissed state is read from the server-resolved
 * `payloadDismissed` value. useSyncExternalStore keeps the popover suppressed
 * during SSR (server snapshot returns true) and surfaces the resolved value on
 * the client. Dismissing writes the cookie (the server's fast read path) and the
 * durable store.
 *
 * @param payloadDismissed The server-resolved dismissed state from the layout payload.
 */
export function useInboxOptionsTipDismissed(payloadDismissed = false) {
  const dismissed = useSyncExternalStore(
    noop,
    () => payloadDismissed,
    () => true,
  )

  const [manuallyDismissed, setManuallyDismissed] = useState(false)
  const savedStateRef = useRef(false)

  const isDismissed = dismissed || manuallyDismissed

  function dismiss() {
    if (savedStateRef.current) {
      return
    }

    savedStateRef.current = true

    const expireTime = new Date(Date.now() + COOKIE_EXPIRY_MS).toUTCString()
    setCookie(COOKIE_NAME, '1', expireTime)
    deleteCookie(LEGACY_COOKIE_NAME)
    setManuallyDismissed(true)
    persistPullsPreferences({inbox_options_tip_dismissed: true})
  }

  return {isDismissed, dismiss}
}
